import SiriusAPI from '@/api'

let cid = Date.now()

let selectedImageId = null
let selectedImageUrl = null

async function uploadImage(file, previewContainer, previewImg, uploadControls) {
  try {
    const formData = new FormData()
    formData.append('file', file)

    const response = await SiriusAPI.image.addImage({ file: formData })

    if (response.item && response.item.id && response.item.url) {
      selectedImageId = response.item.id
      selectedImageUrl = response.item.url
      previewImg.src = response.item.url
      previewContainer.style.display = 'block'
      uploadControls.style.display = 'none'
    }
  } catch (error) {
    console.error('Ошибка загрузки изображения:', error)
    selectedImageId = null
    selectedImageUrl = null
  }
}

function initImageUploader(cid, editor) {
  const fileInput = document.getElementById(`imageUpload_${cid}`)
  const uploadBtn = document.getElementById(`uploadBtn_${cid}`)
  const uploadControls = document.getElementById(`uploadControls_${cid}`)
  const previewContainer = document.getElementById(`imagePreview_${cid}`)
  const previewImg = document.getElementById(`previewImg_${cid}`)
  const removeBtn = document.getElementById(`removeImg_${cid}`)

  const onUpload = () => {
    const file = fileInput.files[0]
    if (!file) {
      return
    }

    uploadImage(file, previewContainer, previewImg, uploadControls)
  }

  const onRemove = () => {
    selectedImageId = null
    selectedImageUrl = null
    previewContainer.style.display = 'none'
    uploadControls.style.display = 'block'
    fileInput.value = ''
  }

  uploadBtn.addEventListener('click', onUpload)
  removeBtn.addEventListener('click', onRemove)

  editor.on('destroy', () => {
    uploadBtn.removeEventListener('click', onUpload)
    removeBtn.removeEventListener('click', onRemove)
  })
}

/* eslint-disable */
export default function initDialog() {
  CKEDITOR.dialog.add('cosmohintDialog', function (editor) {
    const currentCid = cid++
    const hintEditorId = `ckeditorHint_${currentCid}`

    return {
      title: 'Вставка всплывающей подсказки',
      minWidth: 400,
      minHeight: 200,

      contents: [
        {
          id: 'tab-basic',
          label: 'Всплывающая подсказка',

          elements: [
            {
              type: 'text',
              id: 'title',
              label: 'Заголовок',
            },
            {
              type: 'html',
              id: 'text',
              html: `
                <label>Текст <span style="color:red">*</span></label><br>
                <textarea style="min-height:300px;" class="cke_dialog_ui_input_textarea" name="ckeditorHint" id="${hintEditorId}"></textarea>
              `,
              onLoad: function () {
                CKEDITOR.replace(hintEditorId, {
                  toolbar_Quote: [
                    [
                      'Bold',
                      'Italic',
                      'Link',
                      'NumberedList',
                      'BulletedList',
                      'Removeformat',
                    ],
                  ],
                  toolbar: 'Quote',
                })
              },
              validate: function () {
                const getData = CKEDITOR.instances[hintEditorId].getData()
                if (!getData.length) {
                  alert('Текст должен быть заполнен')
                  return false
                }
              },
            },
            {
              type: 'html',
              id: 'imageUploader',
              html: `
                <div style="margin: 15px 0; padding: 10px; border: 1px solid #ddd; border-radius: 4px; background: #f9f9f9;">
                  <label style="font-weight: bold; margin-bottom: 8px; display: block;">Картинка (необязательно)</label>
                  <div id="imageUploadContainer_${currentCid}" style="margin-top: 8px;">
                    <div id="uploadControls_${currentCid}">
                      <input type="file" id="imageUpload_${currentCid}" accept="image/jpeg,image/png,image/gif,image/webp" style="margin-bottom: 8px; padding: 4px;" />
                      <button type="button" id="uploadBtn_${currentCid}" style="padding: 6px 12px; background: #0052CC; color: white; border: none; border-radius: 3px; cursor: pointer; margin-left: 8px;">Загрузить</button>
                    </div>
                    <div id="imagePreview_${currentCid}" style="margin-top: 10px; display: none; padding: 10px; background: white; border-radius: 4px;">
                      <img id="previewImg_${currentCid}" style="max-width: 200px; max-height: 150px; border: 1px solid #ccc; border-radius: 4px; display: block; margin-bottom: 8px;" />
                      <button type="button" id="removeImg_${currentCid}" style="padding: 4px 10px; background: #DE350B; color: white; border: none; border-radius: 3px; cursor: pointer;">Удалить</button>
                    </div>
                  </div>
                </div>
              `,
              onLoad: function() {
                initImageUploader(currentCid, editor)
              }
            },
            {
              type: 'html',
              id: 'displayModeWrapper',
              html: `
                <div style="margin-top: 10px;">
                  <label style="font-weight: bold; display: block; margin-bottom: 8px;">Способ показа подсказки</label>
                  <div>
                    <label style="display: block; margin-bottom: 5px;">
                      <input type="radio" name="displayMode_${currentCid}" value="click" checked style="margin-right: 5px;" />
                      По клику
                    </label>
                    <label style="display: block; margin-bottom: 5px;">
                      <input type="radio" name="displayMode_${currentCid}" value="hover" style="margin-right: 5px;" />
                      По наведению мыши
                    </label>
                    <label style="display: block; margin-bottom: 5px;">
                      <input type="radio" name="displayMode_${currentCid}" value="scroll" style="margin-right: 5px;" />
                      По доскроллу
                    </label>
                  </div>
                </div>
              `
            }
          ],
        },
      ],

      onOk: function () {
        const selectedRadio = document.querySelector(`input[name="displayMode_${currentCid}"]:checked`)
        const displayModeValue = selectedRadio ? selectedRadio.value : 'click'

        let data = {
          title: this.getValueOf('tab-basic', 'title'),
          text: CKEDITOR.instances[hintEditorId].getData(),
          imageId: selectedImageId,
          imageUrl: selectedImageUrl
        }

        data.text = data.text.replace(/\s*\{image_id_\d+\}/g, '')

        if (selectedImageId) {
          const imageTag = `{image_id_${selectedImageId}}`
          data.text = data.text + ` ${imageTag}`
        }

        let span
        span = editor.getSelection().getStartElement()
        let selected = editor.getSelection().getSelectedText()

        if (span && span.hasClass('cosmohint')) {
          span.data('title', data.title)
          span.data('text', data.text)
          span.data('display-mode', displayModeValue)
          if (data.imageId && data.imageUrl) {
            span.data('image-id', data.imageId)
            span.data('image-url', data.imageUrl)
          } else {
            span.removeAttribute('data-image-id')
            span.removeAttribute('data-image-url')
          }
        } else {
          const hintContainerEl = document.createElement('span')

          hintContainerEl.classList.add('cosmohint')
          hintContainerEl.setAttribute('data-text', data.text)
          hintContainerEl.setAttribute('data-title', data.title)
          hintContainerEl.setAttribute('data-display-mode', displayModeValue)
          
          if (data.imageId && data.imageUrl) {
            hintContainerEl.setAttribute('data-image-id', data.imageId)
            hintContainerEl.setAttribute('data-image-url', data.imageUrl)
          }
          
          hintContainerEl.innerHTML = selected

          editor.insertHtml(hintContainerEl.outerHTML)
        }
      },
      onShow: function () {
        let textLimit = function () {
          let limitExceeded = false
          if (CKEDITOR.instances[hintEditorId].getData().length > 200) {
            limitExceeded = true
          }
        }

        let span
        span = editor.getSelection().getStartElement()
        let selected = editor.getSelection().getSelectedText()

        selectedImageId = null
        selectedImageUrl = null
        const previewContainer = document.getElementById(`imagePreview_${currentCid}`)
        const uploadControls = document.getElementById(`uploadControls_${currentCid}`)
        const fileInput = document.getElementById(`imageUpload_${currentCid}`)

        if (previewContainer) {
          previewContainer.style.display = 'none'
        }
        if (uploadControls) {
          uploadControls.style.display = 'block'
        }
        if (fileInput) {
          fileInput.value = ''
        }

        const defaultRadio = document.querySelector(`input[name="displayMode_${currentCid}"][value="click"]`)
        if (defaultRadio) {
          defaultRadio.checked = true
        }

        if (span && span.hasClass('cosmohint')) {
          let data = {}
          data.title = span.data('title')
          data.text = (span.data('text') || '').replace(/\s*\{image_id_\d+\}/g, '')
          const displayModeValue = span.data('display-mode') || 'click'
          const imageId = span.data('image-id')
          const imageUrl = span.data('image-url')
          
          const radioToCheck = document.querySelector(`input[name="displayMode_${currentCid}"][value="${displayModeValue}"]`)
          if (radioToCheck) {
            radioToCheck.checked = true
          }
          
          if (imageId && imageUrl) {
            selectedImageId = parseInt(imageId)
            selectedImageUrl = imageUrl
            setTimeout(() => {
              const previewContainer = document.getElementById(`imagePreview_${currentCid}`)
              const previewImg = document.getElementById(`previewImg_${currentCid}`)
              const uploadControls = document.getElementById(`uploadControls_${currentCid}`)
              
              if (previewContainer && previewImg) {
                previewImg.src = imageUrl
                previewContainer.style.display = 'block'
                if (uploadControls) {
                  uploadControls.style.display = 'none'
                }
              }
            }, 100)
          }

          for (let key in data) {
            switch (key) {
              case 'text':
                CKEDITOR.instances[hintEditorId].setData(data[key])
                window.ckeditor_quote_prevtext = data[key]
                break
              default:
                this.setValueOf('tab-basic', key, data[key])
            }
          }
        } else if (selected.trim() == '') {
          alert(
            'Сначала выделите часть текста, после этого еще раз нажмите на виджет'
          )
          CKEDITOR.dialog.getCurrent().hide()
        } else {
          CKEDITOR.instances[hintEditorId].setData('')
        }
      },
    }
  })
}
